import React from "react";

const Alert = props => (
  <svg width={14} height={14} viewBox="0 0 14 14" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M7 0C3.15 0 0 3.15 0 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7z" fill="#F1AA4E" />
      <path
        d="M6.979 8.5a1.508 1.508 0 0 1-.386-1.035c0-1.372 1.72-1.535 1.72-2.337 0-.36-.28-.663-.924-.663-.586 0-1.078.28-1.44.721L5 4.128C5.62 3.395 6.557 3 7.564 3 9.074 3 10 3.756 10 4.837c0 1.698-1.956 1.826-1.956 2.803 0 .186.094.383.223.488L6.979 8.5zM7.54 11a.956.956 0 0 1-.948-.942c0-.511.433-.942.948-.942.515 0 .948.43.948.942a.956.956 0 0 1-.948.942z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export default Alert;
